///include /assets/js/app/p/card-capture.js
class CardCaptureStripe extends CardCaptureDriver {
    static get type() {
        return "stripe"
    }
    get canCapture() {
        return !!(
            CheckoutInfo.inst.info &&
            CheckoutInfo.inst.info.card &&
            CheckoutInfo.inst.info.card.type == CardCaptureStripe.type && //
            CheckoutInfo.inst.info.card.captureKey
        )
    }
    /**
     *
     * @param {?string} return_url
     * @param {boolean} [from_vue]
     */
    init(return_url = null, from_vue = true) {
        /** @type {HTMLFormElement} */
        //@ts-ignore
        const pf = document.querySelector("#payment-form")
        if(pf && !pf.getAttribute("action")) {
            const action = safeLocalUrl(return_url, null)
            if(action) {
                pf.action = action
            } else {
                throw new Error(`Invalid return URL: ${return_url}`)
            }
        }
        if(!from_vue) {
            /** @type {HTMLButtonElement} */
            //@ts-ignore
            const submit = document.querySelector(
                "#modal-add-card button.btn-primary, #card-details button.btn-primary"
            )
            submit.addEventListener(
                "click",
                async () => {
                    await this.submitForm()
                    location.href = "/account/billing-details"
                }
            )
        }
    }
    /**
     * @param {HTMLFormElement} pf
     */
    async initForm(pf) {
        if(!pf.getAttribute("action")) {
            throw new Error(`No form action, please see errors`)
        }
        this.mountPoint = `#${pf.id}`
        const ci = CheckoutInfo.inst
        const info = await ci.preloadSingle("info")
        await Site.require_once("https://js.stripe.com/v3/")
        await Site.require_once("/assets/js/lib/p/template-loader.js")
        await Site.require_once("/assets/js/shared/stripe-form.js")

        const [capture_key, intent_secret] = JSON.parse(info.card.captureKey)
        this.secret = intent_secret
        const [s, c, n] = await StripeForm.init(capture_key, this.mountPoint)
        this.stripe = s
        this.card = c
        this.cardName = n
    }
    async submitForm() {
        const result = await this.stripe.confirmCardSetup(
            this.secret,
            {
                payment_method: {
                    card: this.card,
                    billing_details: {
                        name: this.cardName.val(),
                    },
                },
            }
        )
        CheckoutInfo.inst.reload(["info"])
        const info = await CheckoutInfo.inst.preloadSingle("info")
        const [capture_key, intent_secret] = JSON.parse(info.card.captureKey)
        if(result.error) {
            throw new Error(result.error.message)
        } else {
            this.secret = intent_secret

            /** @type {HTMLFormElement} */
            //@ts-ignore
            const pf = document.querySelector("#payment-form")
            await $.ajax({
                method: "post",
                url: pf.action,
                data: {
                    token: result.setupIntent.payment_method,
                }
            })
        }
        this.card.destroy()

        if(this.mountPoint) {
            const [s, c, n] = await StripeForm.init(capture_key, this.mountPoint)
            this.stripe = s
            this.card = c
            this.cardName = n
        }
    }
}
CardCaptureDriver.add(CardCaptureStripe)
